/*************************************************/
/* HEADER                                        */
/*************************************************/
export function scrollProgressIndicator() {
    const scrollProgressIndicatorSelector = '.scroll-progress-indicator';
    const targetSelector = '.site-grid-layout__content';
    let scrollTimer;

    const setScrollProgressIndicator = function () {
        const scrollProgressIndicatorElement = document.querySelector(scrollProgressIndicatorSelector);
        if (scrollProgressIndicatorElement) {
            var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var height = document.querySelector(targetSelector).clientHeight;
            var scrolled = (winScroll / height) * 100;

            if (scrolled > 100) {
                scrolled = 100;
            }
            scrollProgressIndicatorElement.style.backgroundPositionX = '-' + scrolled + '%';
        }
    };

    const init = () => {
        // Sticky header
        setScrollProgressIndicator();

        window.addEventListener('scroll', e => {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
                setScrollProgressIndicator();
            }, 10);
        });
    };

    init();

}

